

import {
    Sheet,
    SheetContent,
    SheetDescription,
    SheetHeader,
    SheetTitle,
    SheetTrigger,
} from "@components/shad/sheet"
// import { Drawer } from "vaul"
import { useMediaQuery } from 'usehooks-ts'
import { cn } from "@/lib/utils";
import { textVariants } from "../Text/Text";
import { Drawer, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle, DrawerTrigger } from "../shad/drawer";

interface Props {
    open: boolean;
    setOpen: (val: boolean) => void;
    trigger?: React.ReactNode;
    children: string | JSX.Element | JSX.Element[];
    title: string;
    size?: "xs" | "sm" | "md" | "lg";
    description?: string;
    drawerHeight?: string;
    setter?: 'url' | 'state'
}

export function DrawerSheet({ trigger, title, children, size = "sm", description, drawerHeight, open, setOpen, setter = 'url' }: Props) {
    const matches = useMediaQuery('(min-width: 768px)')
    const width = {
        xs: "xl:w-1/4 md:w-2/4",
        sm: "xl:w-2/6 w-3/6",
        md: "w-3/4",
        lg: "w-full"
    }
    const selectedWidth = width[size]

    if (matches) return (
        <Sheet open={open} onOpenChange={setter === 'url' ? (val) => setOpen(!val) : () => setOpen(false)} >
            <SheetTrigger asChild>
                {trigger}
                {/* <Button variant="outline">Open</Button> */}
            </SheetTrigger>
            <SheetContent className={cn(`${selectedWidth}`)}>
                <SheetHeader>
                    <SheetTitle className={textVariants({ variant: "header", case: "capitalize", size: "xl", font: "semibold" })}>{title}</SheetTitle>
                    <SheetDescription>
                        {description}
                    </SheetDescription>
                </SheetHeader>
                {children}
            </SheetContent>
        </Sheet>
    )

    return (
        <Drawer shouldScaleBackground open={open} onOpenChange={setter === 'url' ? (val) => setOpen(!val) : (val) => setOpen(val)}>
            <DrawerTrigger asChild>
                {trigger}
            </DrawerTrigger>
            <DrawerContent className={`${drawerHeight} dark:bg-grey-800 px-4 max-h-[95vh]`}>
                <DrawerHeader className="text-left">
                    <DrawerTitle className={textVariants({ variant: "header", case: "capitalize", size: "xl", font: "semibold" })}>{title}</DrawerTitle>
                    <DrawerDescription>
                        {description}
                    </DrawerDescription>
                </DrawerHeader>
                {children}
            </DrawerContent>
        </Drawer>
    )
}
